import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useClarity } from '@hooks';

interface Props {
  children: React.ReactNode;
  pageName?: string;
}

export const ClarityPageTracker: React.FC<Props> = ({ children, pageName }) => {
  const location = useLocation();
  const { setTag, trackEvent } = useClarity();

  useEffect(() => {
    try {
      if (!location?.pathname) return;
      
      const currentPage = pageName || location.pathname;
      
      // Add delay to prevent conflicts
      setTimeout(() => {
        setTag('current-page', currentPage);
        setTag('page-path', location.pathname);
        trackEvent(`page-view-${currentPage}`);
      }, 100);
      
    } catch (error) {
      console.warn('Clarity tracking failed:', error);
    }
  }, [location?.pathname, pageName, setTag, trackEvent]);

  return <>{children}</>;
};